module.exports = __webpack_public_path__ + "img/stock-gray.26968675.svg";